import { atom } from 'jotai'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'

export const editorRefreshCallbackAtom = atom<(() => Promise<void>) | undefined>(undefined)

export type UseEditorRefreshArgs = {
	onRefresh: (() => Promise<void>) | undefined
}

/**
 * Hook to set the editor refresh callback.
 * This allows route-level hooks to provide refresh functionality to the editor.
 */
export function useEditorRefresh({ onRefresh }: UseEditorRefreshArgs) {
	const setRefreshCallback = useSetAtom(editorRefreshCallbackAtom)

	useEffect(() => {
		setRefreshCallback(() => onRefresh)
	}, [onRefresh, setRefreshCallback])
}
